import { effect } from '@preact/signals';
import { MAX_PLAYERS, isPvpMode, levelFromXp, type GameMode } from '@cratered/shared';
import { mapName } from './game/maps';
import { levelById } from './game/campaign';
import { discord, lobby, match, profile, screen } from './store';

/** The mode names as Discord shows them; a map so a new mode cannot fall through to the wrong label. */
const MODE_LABEL: Record<GameMode, string> = { versus: 'Versus', brawl: 'Brawl', coop: 'Co-op Siege', campaign: 'Campaign' };

/** Keeps Discord rich presence in step with what the player is doing. */
export function startPresence(): () => void {
  let matchStartedAt = 0;
  let lastKey = '';
  return effect(() => {
    const d = discord.value;
    const l = lobby.value;
    if (!d || !l) return;
    const p = profile.value;
    const level = p ? levelFromXp(p.xp).level : 1;
    const playing = l.players.filter((x) => !x.spectator && x.connected).length;
    const mode = MODE_LABEL[l.settings.mode];
    const s = screen.value;
    const m = match.value;

    let details: string;
    let state: string;
    let startedAt: number | undefined;
    if (s === 'match' && m) {
      if (!matchStartedAt) matchStartedAt = Math.floor(Date.now() / 1000);
      startedAt = matchStartedAt;
      const lvl = levelById(m.settings.campaignLevelId);
      details = m.settings.mode === 'campaign' && lvl ? `Campaign ${lvl.index} — ${lvl.name}` : `${mode} on ${mapName(m.settings.map)}`;
      state = isPvpMode(m.settings.mode) ? `${m.players.length} moles fighting` : `Lv ${level}`;
    } else {
      matchStartedAt = 0;
      details = s === 'locker' ? 'In the Locker' : s === 'results' ? 'Checking the results' : 'In the lobby';
      state = `${mode} · ${playing} of ${MAX_PLAYERS[l.settings.mode]}`;
    }
    const key = `${details}|${state}|${startedAt ?? ''}`;
    if (key === lastKey) return;
    lastKey = key;
    void d.setActivity({
      details,
      state,
      startedAt,
      party: s === 'match' ? undefined : { size: [Math.max(1, playing), MAX_PLAYERS[l.settings.mode]] },
      largeImage: l.settings.map,
      largeText: mapName(l.settings.map),
      smallImage: (p?.equipped.body ?? 'body.lean').replace('.', '_'),
      smallText: `Level ${level}`,
    });
  });
}
